import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { BackLink } from '../Navigation/BackLink';

interface EntityViewLayoutProps {
  closeTo: string;
  backTo: string;
  backLabel: string;
  title: string;
  headerAction?: React.ReactNode;
  footerActions?: React.ReactNode;
  isLoading?: boolean;
  loadingText?: string;
  children: React.ReactNode;
}

export const EntityViewLayout: React.FC<EntityViewLayoutProps> = ({
  closeTo,
  backTo,
  backLabel,
  title,
  headerAction,
  footerActions,
  isLoading = false,
  loadingText = 'Loading...',
  children,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-gray-500">{loadingText}</div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-end mb-2">
        <Link to={closeTo} aria-label="Close" className="hover:opacity-70">
          <X size={20} color="#667085" strokeWidth={1.66667} aria-hidden="true" />
        </Link>
      </div>

      <BackLink to={backTo} label={backLabel} />

      <div className="flex justify-between items-center mb-6">
        <h1 className="text-neutral-900">{title}</h1>
        {headerAction}
      </div>

      {children}

      {footerActions && (
        <>
          <hr className="border-t-2 border-[#EAECF0] my-6" />
          <div className="flex justify-end gap-3">{footerActions}</div>
        </>
      )}
    </div>
  );
};

export default EntityViewLayout;
